var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDegradeDeCouleurNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2033,
    height: 943,
    viewBox: "0 0 2033 943",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2033 943L-4.52995e-05 943L3.71402e-05 -0.000208248L2033 -3.05176e-05L2033 943Z",
    fill: "url(#paint0_radial_282_22453)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_282_22453",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1927.03 212.177) rotate(-173.704) scale(1934.78 148743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#49B857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EFC556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#A6163F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDegradeDeCouleurNew);
export default __webpack_public_path__ + "static/media/degrade_de_couleurNew.0df9866f8c9a5354022f02855c90fda7.svg";
export { ForwardRef as ReactComponent };